<template>
  <section>
    <b-field label="Nombre del cliente">
      <b-autocomplete
        v-model="cliente"
        id="cliente"
        placeholder="Escribe el nombre del cliente"
        :keep-first="true"
        :data="clientesFiltrados"
        field="nombre"
        @input="buscarClientes"
        @select="seleccionarCliente"
        size="is-mediun"
      >
        <template v-slot="{ option }">
          <div>
            <strong>{{ option.nombre }}</strong> - {{ option.telefono }} -
            {{ option.nit }}
          </div>
        </template>
      </b-autocomplete>
    </b-field>
    <div class="notification is-info mt-2" v-if="clienteSeleccionado">
      <button class="delete" @click="deseleccionarCliente"></button>
      <p>
        Cliente: <b>{{ clienteSeleccionado.nombre }}</b>
      </p>
      <p>
        Teléfono: <b>{{ clienteSeleccionado.telefono }}</b>
      </p>
    </div>
    <!-- Cambiar clase según tipoCliente -->
  </section>
</template>
  
  <script>
import HttpService from "../../Servicios/HttpService";

export default {
  name: "BusquedaCliente",

  data: () => ({
    cliente: "",
    clientesEncontrados: [],
    clienteSeleccionado: null,
    usarSaldo: false,
  }),

  methods: {
    deseleccionarCliente() {
      this.clienteSeleccionado = null;
      this.usarSaldo = false; // Reiniciar checkbox al deseleccionar cliente
    },
    emitirUsoSaldo() {
      if (this.usarSaldo) {
        this.$emit("usarSaldo", parseInt(this.clienteSeleccionado.saldo));
      } else {
        this.$emit("usarSaldo", 0); // Emitir 0 si desmarcan la casilla
      }
    },
    seleccionarCliente(opcion) {
      if (!opcion) return;
      this.clienteSeleccionado = opcion;
      this.usarSaldo = false; // Reiniciar el estado del checkbox

      this.$emit("seleccionado", this.clienteSeleccionado);
      setTimeout(() => (this.cliente = ""), 10);
    },

    buscarClientes() {
      let payload = {
        accion: "obtener_por_nombre",
        nombre: this.cliente,
      };

      HttpService.obtenerConConsultas("clientes.php", payload).then(
        (clientes) => {
          this.clientesEncontrados = clientes;
        }
      );
    },
  },

  computed: {
    clientesFiltrados() {
      if (!this.cliente) return this.clientesEncontrados; // Si no hay texto en cliente, retorna todo
      return this.clientesEncontrados.filter((opcion) => {
        const nombre = opcion.nombre
          ? opcion.nombre.toString().toLowerCase()
          : "";
        const telefono = opcion.telefono
          ? opcion.telefono.toString().toLowerCase()
          : "";
        const nit = opcion.nit ? opcion.nit.toString().toLowerCase() : "";
        const cliente = this.cliente.toString().toLowerCase();

        return (
          nombre.includes(cliente) ||
          telefono.includes(cliente) ||
          nit.includes(cliente)
        );
      });
    },
    clienteClass() {
      if (!this.clienteSeleccionado || !this.clienteSeleccionado.tipoCliente) {
        return "normal-cliente"; // Clase predeterminada
      }
      switch (this.clienteSeleccionado.tipoCliente) {
        case "preferencial":
          return "preferencial-cliente";
        case "negro":
          return "negro-cliente";
        default:
          return "normal-cliente";
      }
    },
  },
};
</script>
  
  <style scoped>
.cliente-detalle {
  padding: 1rem;
  border-radius: 8px;
  color: white;
}

/* Estilo predeterminado */
.normal-cliente {
  background-color: #209cee; /* Azul */
}

/* Estilo para clientes preferenciales */
.preferencial-cliente {
  background-color: rgb(202, 180, 54); /* Dorado */
  color: black;
}

/* Estilo para clientes "negro" */
.negro-cliente {
  background-color: black; /* Negro */
}
.saldo-destacado {
  font-size: 2rem; /* Tamaño de letra grande */
  font-weight: bold; /* Negrita */
  color: green; /* Color destacado */
  text-align: center; /* Centrado opcional */
}
.usar-saldo-checkbox span {
  font-size: 0.8rem; /* Tamaño pequeño */
  color: #555; /* Color más tenue */
  margin-left: 5px; /* Espaciado entre el checkbox y el texto */
}

.usar-saldo-checkbox input {
  transform: scale(0.8); /* Hacer el checkbox más pequeño */
  margin-right: 5px;
}
</style>